import { useEffect, useState } from "react";
import { fetchComments, fetchFilesSupport } from "../../../../../../api/tas";

interface Props {
  id: number | string;
}

const SupportItemCounts = ({ id }: Props) => {
  const [commentsCount, setCommentsCount] = useState<number | null>(null);
  const [attachmentsCount, setAttachmentsCount] = useState<number | null>(null);

  useEffect(() => {
    let active = true;

    (async () => {
      const [comments, files] = await Promise.all([
        fetchComments(String(id)).catch(() => null),
        fetchFilesSupport(String(id)).catch(() => null),
      ]);
      if (!active) return;
      setCommentsCount((comments?.content ?? []).length);
      setAttachmentsCount((files?.content ?? []).length);
    })();

    return () => {
      active = false;
    };
  }, [id]);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <span className="rioglyph rioglyph-chat text-color-gray" />
        <span className="text-size-12 text-color-gray">{commentsCount ?? "-"}</span>
      </span>

      <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
        <span className="rioglyph rioglyph-paper-clip text-color-gray" />
        <span className="text-size-12 text-color-gray">{attachmentsCount ?? "-"}</span>
      </span>
    </div>
  );
};

export default SupportItemCounts;
